import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCurrencyInputWrapper } from 'src/components/CookbookCurrencyInputWrapper/CookbookCurrencyInputWrapper';
import { ENTERPRISE_MAX_BUDGET_DOLLAR_AMOUNT } from 'src/components/CurrencyInput/CurrencyInput';

export interface BudgetCurrencyInputProps {
  name: string;
  id: string;
  disabled?: boolean;
  label?: string;
}

export function BudgetCurrencyInput({
  label,
  name,
  id,
  disabled = false,
}: BudgetCurrencyInputProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookCurrencyInputWrapper
      blockWidth
      inputSize="small"
      currency="USD"
      locale="en-US"
      precision={2}
      disabled={disabled}
      error={errors[name]}
      id={id}
      name={name}
      control={control}
      label={label}
      placeholder="Set amount"
      rules={{
        required: 'Amount is required',
        max: {
          value: ENTERPRISE_MAX_BUDGET_DOLLAR_AMOUNT,
          message: `Amount should be $${ENTERPRISE_MAX_BUDGET_DOLLAR_AMOUNT} or less`,
        },
        min: {
          value: 0.01,
          message: `Amount should be greater than $0`,
        },
      }}
    />
  );
}
